export default __webpack_public_path__ + "static/media/main-logo.29061466.jpg";